import { defineFeature } from "../core/composition/define-feature.js";
import { endOfStream } from "../behaviors/dom/end-of-stream.js";
import { setupMediaSource } from "../behaviors/dom/setup-mediasource.js";
import { updateMediaSourceDuration } from "../behaviors/dom/update-mediasource-duration.js";
//#region src/playback/features/media-source.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [
	setupMediaSource,
	updateMediaSourceDuration,
	endOfStream
];
/** The config defaults the feature contributes. */
const defaultConfig = {};
/** The state values the feature seeds. */
const initialState = {};
/**
* Plays through Media Source Extensions: attaches a MediaSource to the media element, keeps its duration current, and
* ends the stream once every composed track type has loaded its last segment.
*
* Requires:
*
* - A writer of `presentation.duration`, such as `calculateDurationFeature`; without one, the MediaSource keeps its
*   default duration, and a live stream never gets its infinite duration and stalls.
* - A writer of `state.currentTime`, such as `currentTimeFeature`; without one, the stream never ends.
*/
const mediaSourceFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, defaultConfig, initialState, mediaSourceFeature };
